// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const stores = {
  id: "stores",
  title: "Stores and VMs",
  type: "group",
  children: [
    {
      id: "stores-collapse",
      title: "Stores",
      type: "collapse",
      children: [
        {
          id: "stores",
          title: "Stores",
          type: "item",
          url: "/stores",
        },
        {
          id: "store-categories",
          title: "Store Categories",
          type: "item",
          url: "/stores/categories",
        },
        {
          id: "vending-machines",
          title: "Vending Machines",
          type: "item",
          url: "/vending-machines",
        },
        {
          id: "vending_machine_categories",
          title: "VM Categories",
          type: "item",
          url: "/vending-machines/categories",
        },
      ],
    },
  ],
};

export default stores;
